import HierarchyManagementDashboardPage from "./HierarchyManagementDashboardPage";
import { useStructuralHierarchyQuery } from "../../utilities/queries/useStructuralHierachyQuery";
import { useMemo } from "react";
import { LocationModalProvider } from "../../utilities/Contexts/LocationModalContext";
import { constructHierarchy } from "../../utilities/HierarchyOperations/constructHierarchy";
import { useStore } from "../../utilities/appStore";
import Spinner from "../../components/UISpinner/UISpinner";


export default function HierarchyManagementDashboardPageModel() {

    let isGlobalLoading = useStore((state) => state.isLoading);
    const { data, isLoading: isHierarchyDataLoading, error } = useStructuralHierarchyQuery();
    const isLoading = isHierarchyDataLoading || isGlobalLoading;
    const transformedData = useMemo(() => {
        if (!data || data?.length === 0) return null; // Avoid calling function when response is null
        return constructHierarchy(data);
    }, [data]);
    

    let rootIndex = transformedData?.root?.children[0];
    let expandRoot = [];
    if (rootIndex) {
        expandRoot = transformedData[rootIndex]?.children?.length > 0 ? [rootIndex] : expandRoot;
    }
    return (
        <LocationModalProvider>
            {isLoading && <Spinner text="Loading tree..." />}
            {!isLoading && <HierarchyManagementDashboardPage expandRoot={expandRoot} hierarchyData={transformedData} error={error}></HierarchyManagementDashboardPage>}
        </LocationModalProvider>
    )
}